export default "__VITE_ASSET__Bjn3p3qu__"